import type { ExchangeBetslipCapabilities, SportsbookBetslipCapabilities } from "../../../contract";
import type { BetslipApplicationState } from "../BetslipApplicationState";

export const getSportsbookBetslipCapabilities = (state: BetslipApplicationState): SportsbookBetslipCapabilities =>
  state.sportsbookCapabilities;

export const getExchangeBetslipCapabilities = (state: BetslipApplicationState): ExchangeBetslipCapabilities =>
  state.exchangeCapabilities;
